import {
  type FileManagerItem,
  FileManagerItemApproveAction,
  FileManagerItemContextMenu,
  FileManagerItemCopyAction,
  FileManagerItemDeleteAction,
  FileManagerItemDetailsAction,
  FileManagerItemDndWrapper,
  FileManagerItemMoveAction,
  FileManagerItemOpenAction,
  FileManagerItemRenameAction,
  FileManagerItemShareActions,
  FileManagerItemTagsAction,
  FileManagerMenuSeparator,
  useFileManager,
} from "@/components/core/FileManager";
import { FileManagerItemCard } from "@/components/core/FileManager/components/FileManagerItemCard/FileManagerItemCard.tsx";
import { isApprovedFolderName } from "@/components/features/FileManager/fileTags.utils";
import {
  isPreviewableFile,
  openFileInNewTab,
} from "@/components/features/FileManager/filePreview.utils";
import { useFileManagerPreview } from "@/components/features/FileManager/FileManagerPreview";

export { openFileInNewTab };

interface FileCardProps {
  item: FileManagerItem;
  isOsDragOver?: boolean;
}

export function FileCard({ item, isOsDragOver }: FileCardProps) {
  const { openFolder, breadcrumb, resolveDownloadUrl } = useFileManager();
  const { openPreview } = useFileManagerPreview();
  const isInApprovedFolder = isApprovedFolderName(breadcrumb[0]?.name);

  return (
    <FileManagerItemDndWrapper item={item} isOsDragOver={isOsDragOver}>
      <FileManagerItemContextMenu
        item={item}
        menuContent={
          <>
            <FileManagerItemOpenAction item={item} />
            <FileManagerMenuSeparator />
            <FileManagerItemRenameAction item={item} />
            <FileManagerItemMoveAction item={item} />
            <FileManagerItemCopyAction item={item} />
            <FileManagerMenuSeparator />
            <FileManagerItemTagsAction item={item} />
            {!isInApprovedFolder && <FileManagerItemApproveAction item={item} />}
            <FileManagerItemShareActions item={item} />
            <FileManagerItemDetailsAction item={item} />
            <FileManagerMenuSeparator />
            <FileManagerItemDeleteAction item={item} />
          </>
        }
      >
        <FileManagerItemCard
          item={item}
          onOpen={(clickedItem) => {
            if (clickedItem.type === "FOLDER") {
              openFolder(clickedItem.id, clickedItem.name);
            } else if (isPreviewableFile(clickedItem)) {
              openPreview(clickedItem);
            } else {
              void openFileInNewTab(clickedItem, resolveDownloadUrl);
            }
          }}
        />
      </FileManagerItemContextMenu>
    </FileManagerItemDndWrapper>
  );
}
